import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';
import { useStore } from '../../../hooks/useStore';

export const ExportStepWrapper = observer(() => {
  const { step } = useParams();
  const exportStore = useStore().exportFlowStore;

  const currentStep = exportStore.getCurrentStep(parseInt(step as string) - 1);
  if (!currentStep) return null;

  return <currentStep.component />;
});
